import React, { useState, useEffect } from "react";
import { Box, Modal, Tabs, Tab, Typography } from "@mui/material";
import AdminDashboard from "../../Admin/Dashboard/Dashboard";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import UserPropertiesTable from "./UserPropertiestable";
import axios from "axios";

const DisplayUserProperties = () => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const [filteredProperties, setFilteredProperties] = useState([]);

  const fetchProperties = async () => {
    try {
      setLoading(true);
      const response = await axios.get("https://landnest.net:81/property/");
      setProperties(response.data);
      filterProperties(0, response.data); // Initial filter for the first tab
    } catch (error) {
      console.error("Error fetching properties:", error);
      toast.error("Failed to fetch properties. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const filterProperties = (tabIndex, propertiesToFilter = properties) => {
    let filtered = [];
    switch (tabIndex) {
      case 0: // Buyer Properties (sell)
        filtered = propertiesToFilter.filter(property => property.type === "sell");
        break;
      case 1: // Rent Properties (rent)
        filtered = propertiesToFilter.filter(property => property.type === "rent");
        break;
      case 2: // Lease Properties (lease)
        filtered = propertiesToFilter.filter(property => property.type === "lease");
        break;
      default:
        filtered = propertiesToFilter;
    }
    setFilteredProperties(filtered);
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    filterProperties(newValue);
  };

  useEffect(() => {
    fetchProperties();
  }, []);

  return (
    <>
      <AdminDashboard />
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#f5f5f5",
          px: { xs: 2, md: 4 },
          py: { xs: 2, md: 4 },
          gap: 1,
        }}
      >
        <Typography variant="h4" sx={{ mb: 0 }}>User Uploaded Properties</Typography>
        <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
          <Tabs value={activeTab} onChange={handleTabChange} centered>
            <Tab label="Buyer Properties" />
            <Tab label="Rent Properties" />
            <Tab label="Lease Properties" />
          </Tabs>
        </Box>
        
        <UserPropertiesTable 
          properties={filteredProperties} 
          loading={loading} 
          fetchProperties={fetchProperties}
        />
        
        <ToastContainer />
      </Box>
    </>
  );
};

export default DisplayUserProperties;